module.exports = __webpack_public_path__ + "img/2.40c613c0.png";